import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Logo } from "../components/Logo";

export default function AuthCallback() {
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const search = window.location.search || "";
        const query = new URLSearchParams(search);

        // SocialPulse OIDC round-trip: ?code=&state= (or ?error=)
        if (query.get("code") && query.get("state")) {
            const backend = process.env.REACT_APP_BACKEND_URL;
            window.location.replace(
                `${backend}/api/auth/socialpulse/callback${search}`,
            );
            return;
        }
        if (query.get("error")) {
            navigate(`/login?sso_error=${encodeURIComponent(query.get("error"))}`, { replace: true });
            return;
        }

        // Emergent Google Auth: #session_id=...
        const hash = location.hash || window.location.hash;
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(match[1]);
        window.history.replaceState(null, "", window.location.pathname + window.location.search);

        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id: sessionId });
                setUser(data);
                navigate("/dashboard", { replace: true, state: { user: data } });
            } catch {
                navigate("/login", { replace: true });
            }
        })();
    }, [location, navigate, setUser]);

    return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-6">
            <Logo />
            <div className="font-mono text-sm text-muted-foreground">Signing you in…</div>
        </div>
    );
}
